/**
 * Clause drag-and-drop contract (DOCX-native editor).
 *
 * A single native HTML5 drag/drop channel between the clause sidebar (source)
 * and the editor canvas (target) — no drag library. The clause's CKEditor HTML
 * body travels on a custom MIME type so the editor only reacts to clause drags
 * and ignores ordinary text/selection drags.
 */

import type { ClauseBodyFormat } from './clauseBody';

/** Custom dataTransfer type carrying the clause payload (JSON: {format, body}). */
export const CLAUSE_DND_MIME = 'application/x-propdocs-clause';

/** What travels on the drag: the body plus which representation it is. */
export interface ClauseDndPayload {
  format: ClauseBodyFormat;
  /** DOCX: base64 of the .docx zip. HTML: the markup string. */
  body: string;
}

export function encodeClauseDnd(payload: ClauseDndPayload): string {
  return JSON.stringify(payload);
}

export function decodeClauseDnd(raw: string): ClauseDndPayload | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.body === 'string' && (parsed.format === 'docx' || parsed.format === 'html')) {
      return parsed as ClauseDndPayload;
    }
  } catch {
    /* not our envelope */
  }
  return null;
}
